// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8w-3";
export var contentContainer = "_8w-0";
export var editorContainer = "_8w-1";
export var quillInputForm = "_8w-2";
export var zoneDivider = "_8w-4";